// 数据接口
const API_URLS = {
  EMAIL_LOGIN: '/thsyun/openplat-api/account/login',
  EMAIL_REGISTER: '/thsyun/openplat-api/account/register',
  EMAIL_CAPTCHA: '/thsyun/openplat-api/account/get_verify_code',
  USER_LOGOUT: '/thsyun/openplat-api/account/logout',
  NEWS_LIST: '/thsyun/openplat-api/home_page/get_news_list',
  NEWS_TYPE_LIST: '/thsyun/openplat-api/home_page/get_news_type',
  GROUP_TYPE: '/thsyun/openplat-api/group_category/group',
  GROUP_LIST: '/thsyun/openplat-api/component/get_category_all',
  INFO: '/thsyun/openplat-api/account/get_info',
  ORDER_STATUS: '/thsyun/openplat-api/order/order_status',
  ORDER: '/thsyun/openplat-api/order/get_list',
  COMPONENT: '/thsyun/openplat-api/component/customer/get_detail',
  ADDCAR: '/thsyun/openplat-api/shopping_cart/add_product',
  REMOVE_CAR: '/thsyun/openplat-api/shopping_cart/delete_product',
  GETCAR: '/thsyun/openplat-api/shopping_cart/get_list',
  SUBMITCAR: '/thsyun/openplat-api/shopping_cart/submit',
  ALL_COMPONENT: '/thsyun/openplat-api/component/get_all',
  PRODUCT_DETAIL: '/thsyun/openplat-api/component/visitor/get_detail',
  PERSONAL_MSG: '/thsyun/openplat-api/account/modify_info',
  HOME_CYCLE: '/thsyun/openplat-api/home_page/pictures_cycle',
  // 首页轮播
  FAST_CONTRACT: '/thsyun/openplat-api/home_page/pre_contract',
  // 立即预约
  SOLUTION: '/thsyun/openplat-api/home_page/get_solutions',
  // 解决方案
  HOME_MENU: '/thsyun/openplat-api/home_page/menu',
  // 首页菜单获取
  PRODUCT_MENU: '/thsyun/openplat-api/product/products_config',
  RECOMMEND_LABEL: '/thsyun/openplat-api/label/recommend_label',
  // 热门标签推荐
  QUERY_LABEL: '/thsyun/openplat-api/label/query_label',
  // 查询标签
  QUERY_INTERFACE: '/thsyun/openplat-api/component/get_associated_interface',
  // 获取关联接口
  /* 数据接口相关 */
  INTERFACE_DETAIL: '/thsyun/openplat-api/interface/get_detail',
  INTERFACE_DEBUG: '/thsyun/openplat-api/interface/debug',
  ALL_INTERFACE_CATEGORY: '/thsyun/openplat-api/interface/get_all',
  ALL_INTERFACE_BY_CATEGORY: '/thsyun/openplat-api/interface/get_category_all',
  CHECK_TOKEN: '/thsyun/openplat-api/account/auto_login',
  // 检查token是否有效
  /* 语音合成 */
  TEXT_TO_SPEECH_MODEL_LIST: '/text-to-speech-api/cuttor/api/v2/train/get/default_models',
  TEXT_TO_SPEECH_COMPOSE: '/text-to-speech-api/GXPT/tts/v3/get/result',
  PRODUCT_USE: '/thsyun/openplat-api/presentation/info',
  PRODUCT_ROLE: '/thsyun/openplat-api/account/check_presentation'
};
export default API_URLS;